import { Image } from 'components/Image'
import { Stink } from 'components/Stink'
import styled from 'styled-components'

const FigCaption = styled.figcaption`
  padding-top: 1.5rem;
  font-size: 15px;
  line-height: 21px;
  color: var(--text-color);
  font-family: var(--font-plex);
`
const Title = styled.div`
  font-weight: 700;
`
const Caption = styled.div`
  font-size: 15px;
  margin-bottom: 8px;
  padding-top: 1.5rem;
  font-size: 15px;
  line-height: 21px;
  color: var(--text-color);
  font-family: var(--font-plex);
`
const Source = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: var(--gray-3);
  font-family: var(--font-plex);
`
const I = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;
  background-color: var(--red-bright-3);
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
  color: var(--brandblue-main);
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`
const Bold = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;

  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`

const IB = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;
  background-color: var(--blue-bright-3);
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
  color: var(--brandblue-main);
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`

const B = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;
  /* border-bottom: 2px solid var(--red-main); */
  background-color: var(--brandblue-bright-2);
  color: #fff;
  letter-spacing: 0.3px;
  font-size: 17px;
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`
const BG = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;
  border-bottom: 2px solid var(--beige-main);
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
`
const BHB = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;
  background-color: var(--brandblue-bright-4);
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
  color: var(--brandblue-main);
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`
const BR = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;
  /* border-bottom: 2px dotted var(--red-main); */

  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  background-image: linear-gradient(90deg, var(--red-main), var(--red-main));
  background-repeat: repeat-x;
  background-position: bottom;
  background-size: 2px 2px;
  transition: all 0.1s ease-in-out;
  background-origin: content-box;
`
const BB = styled.span`
  font-family: var(--font-plex);
  font-weight: 700;
  border-bottom: 2px solid var(--brandblue-main);
  padding: 2px;
  padding-left: 5px;
  padding-right: 5px;
`
const Chapter = styled.h2`
  width: 100%;
  text-align: center;

  font-size: 50px;
  line-height: 1.2em;

  span {
    font-family: var(--font-plex);
    margin-top: 20px;
    font-weight: 300;
    display: inline-block;
    line-height: 1.3em;
    padding-left: 10%;
    padding-right: 10%;
    width: 80%;
    font-size: 22px !important;
    &.date {
      color: var(--beige-main);
      font-size: 15px !important;
      margin-top: 0 !important;
      line-height: 1em;
    }
  }

  @media screen and (max-width: 711px) {
    font-size: 40px;
    span {
      font-size: 18px !important;
      &.date {
        font-size: 15px !important;
      }
    }
  }
`

export const ContentByDay_de = {
  '2022-02-23': (
    <>
      <p>
        Der Konflikt zwischen der Ukraine und Russland begann schon im Jahr
        2014. Damals besetzten die Russen die unter ukrainischer Hoheit stehende{' '}
        <I>Schwarzmeer-Halbinsel Krim</I> und annektierten sie
        völkerrechtswidrig. Zudem unterstützten sie prorussische Separatisten in
        der Ostukraine, die sich gegen die westlich orientierte Regierung in
        Kiew auflehnten und einen <I>Teil der Regionen Donezk und Luhansk</I>{' '}
        erobern konnten.
      </p>
      <p>
        Dann erklärt Russlands Präsident Wladimir Putin im Februar 2022 die
        abtrünnigen Gebiete auf einmal zu «unabhängigen Volksrepubliken», die
        vor ukrainischen Angriffen geschützt werden müssten. Russische Truppen
        drängen daraufhin in die besetzten Gebiete vor und marschieren an
        verschiedenen Stellen der ukrainischen Grenze auf.
      </p>
    </>
  ),
  '2022-02-25': (
    <>
      <Chapter>
        1 &ndash; Der Überfall
        <span className='date'>Februar bis März 2022</span>
        <span>
          Die Russen erobern grosse Gebiete und stossen fast bis nach Kiew vor
        </span>
      </Chapter>
      <p>
        Russlands Angriff auf die Ukraine beginnt in der Nacht auf den 24.
        Februar. Mehrere Städte werden bombardiert, darunter{' '}
        <Bold>Kiew, Charkiw, Dnipro, Kramatorsk und Berdjansk.</Bold> Russische
        Truppen marschieren zudem vom Norden, Osten und Süden ins Land ein und
        stossen mit ihrem Blitzangriff weit vor.
      </p>
      <p>
        Nur einen Tag nach Beginn der Invasion können die Russen bereits grosse
        Gebietsgewinne für sich beanspruchen. Im Norden sind sie so weit
        vorgerückt, dass sie kurz vor Kiew stehen. Satellitenbilder zeigen:
        Kilometerlange Konvois aus Panzern und anderen Militärfahrzeugen bewegen
        sich auf die Hauptstadt zu.{' '}
        <Stink href='997302848734'>
          Es sieht alles nach einem schnellen russischen Sieg aus.
        </Stink>
      </p>
      <Image
        src={require('../../assets/images/convoy.jpg')}
        caption='Rollt auf die Hauptstadt zu: Ein russischer Militärkonvoi am Rand des Antonow-Flughafens in der Nähe von Kiew.'
        source='Foto: Maxar, Keystone'
      />
    </>
  ),
  '2022-03-02': (
    <>
      <p>
        Auch im Süden brauchen die Invasoren weniger als eine Woche, um die
        gesamte Küste von der Region Cherson bis zum Separatistengebiet im Osten
        zu erobern – mit Ausnahme von <B>Mariupol.</B> Die wichtige Hafenstadt
        wird seither belagert und bombardiert. Strom, Gas und Wasserversorgung
        fallen aus, die Lage der Einwohner ist katastrophal.
      </p>
      <p>
        Für besonderes Entsetzen sorgt ein Raketenangriff am 9. März auf eine
        Geburtsklinik in Mariupol. Die Russen behaupten, das Gebäude sei von
        ukrainischen Kämpfern genutzt worden. Von ukrainischer Seite wie auch
        von der UNO jedoch heisst es, dass es sich um ein funktionierendes
        Entbindungskrankenhaus gehandelt habe.
      </p>
      <Image
        src={require('../../assets/images/birthclinic.jpg')}
        caption='Dieses Bild ging um die Welt: Ukrainische Rettungskräfte tragen eine verletzte schwangere Frau aus der bombardierten Geburtsklinik.'
        source='Foto: Evgeniy Maloletka (AP, Keystone)'
      />
    </>
  ),
  '2022-03-24': (
    <>
      <p>
        Unablässig rücken die Russen weiter vor. Einen Monat nach Kriegsbeginn
        erreicht der Vorstoss seinen vorläufigen Höhepunkt: Die Invasoren nehmen
        im Osten das gesamte{' '}
        <BR>Grenzgebiet zwischen Charkiw und dem Separatisten&shy;gebiet</BR>{' '}
        ein und kontrollieren jetzt etwa 163’000 Quadratkilometer – 27 Prozent
        oder fast ein Drittel der Ukraine.
      </p>
    </>
  ),
  '2022-03-05': (
    <>
      <Chapter>
        2 &ndash; Der Widerstand
        <span className='date'>März bis April 2022</span>
        <span>Die Ukrainer stoppen den Vormarsch und schlagen zurück</span>
      </Chapter>
      <p>
        Doch der russische Vorstoss ist zu diesem Zeitpunkt bereits ins Stocken
        geraten. Die Einkesselung <B>Kiews</B> scheitert, weil sich der
        ukrainische Widerstand rund um die Hauptstadt als zäher entpuppt als
        erwartet. Anfang März können die Ukrainer bei der zweitgrössten Stadt{' '}
        <B>Charkiw</B> im Osten erstmals ein{' '}
        <IB>grösseres Gebiet zurückerobern</IB> – ein Wendepunkt.
      </p>
    </>
  ),
  '2022-03-23': (
    <>
      <p>
        Denn ab Mitte März gehen die ukrainischen Streitkräfte definitiv in die{' '}
        <IB>Gegenoffensive</IB> über. Zuerst drängen sie die Invasoren bei{' '}
        <BR>Mikolajiw</BR> im Süden zurück, dann auch bei <BR>Kiew</BR> und rund
        um <BR>Charkiw.</BR>
      </p>
    </>
  ),
  '2022-04-06': (
    <>
      <p>
        Die Russen werden zum Rückzug gezwungen und ziehen ihre Streitkräfte
        innerhalb weniger Tage aus dem Norden ab. So schnell sie das Gebiet zu
        Beginn der Invasion eingenommen haben, so schnell müssen sie es jetzt
        wieder aufgeben. Die Ukrainer haben am 6. April den ganzen{' '}
        <IB>Norden und Nordosten</IB> ihres Territoriums zurückerobert.
      </p>
      <p>
        Nach dem Abzug russischer Truppen aus der Umgebung von Kiew werden im{' '}
        <B>Vorort Butscha</B> zahlreiche hingerichtete Zivilisten und
        Massengräber entdeckt. Berichte über ermordete Männer, Frauen und Kinder
        kommen auch aus Dörfern wie Dmitriwka, Motischin oder der Stadt Irpin.
        Die Gräueltaten sorgen weltweit für grosses Entsetzen und Empörung.
      </p>

      <Image
        src={require('../../assets/images/butcha1.jpg')}
        caption='Er spricht von Völkermord: Der ukrainische Präsident Wolodimir Selenski ist vor Ort in Butscha sichtlich mitgenommen.'
        source='Foto: AFP'
      />

      <p>
        Moskau streitet alles ab.{' '}
        <Stink href='223312749371'>
          Doch es gibt Bilder, es gibt Videos, es gibt Zeugen und es gibt
          Dokumente, die belegen, was in Butscha passiert ist.
        </Stink>{' '}
        Der Vorort von Kiew wird nach dem Rückzug der russischen Truppen im
        Frühjahr zu einer Art bewohntem Mahnmal für Kriegsverbrechen, die
        mutmasslich unter der Besatzung verübt worden sind.
      </p>

      <Image
        src={require('../../assets/images/butcha2.jpg')}
        caption='Kriegsverbrechen: Viele der ermordeten Zivilisten in Butscha wurden gefesselt und exekutiert.'
        source='Foto: Vadim Ghirda (Keystone)'
      />
    </>
  ),
  '2022-04-07': (
    <>
      <Chapter>
        3 &ndash; Zwei neue Fronten
        <span className='date'>April bis Mai 2022</span>
        <span>Die Russen konzentrieren sich auf den Osten und den Süden</span>
      </Chapter>

      <p>
        Nach dem Rückzug im Norden konzentrieren die Russen ihre Kräfte auf den
        Osten, wo sie einen neuen Vorstoss südlich von Charkiw lancieren. Das
        Ziel ist es hier, eine Schneise nach Süden zu schlagen und so die
        ukrainischen Truppen in der Region zu isolieren. Die{' '}
        <BHB>Regionen Luhansk und Donezk, die zusammen den Donbass bilden,</BHB>{' '}
        sollen vollständig erobert und von der Ukraine abgetrennt werden.
      </p>
      <p>
        Spätestens jetzt wird klar, dass die russischen Streitkräfte keinen
        Unterschied zwischen Soldaten und Zivilisten machen. Am 8. April führen
        sie einen Raketenangriff auf einen Bahnhof in der{' '}
        <Bold>Stadt Kramatorsk</Bold> durch. Mindestens 50 Zivilisten – darunter
        Frauen und Kinder – werden getötet und mehr als 100 verwundet. Die
        meisten von ihnen wollten sich nach Angaben der Behörden in Sicherheit
        bringen.
      </p>
    </>
  ),
  '2022-04-14': (
    <>
      <p>
        Die Ukrainer können ein paar Tage später zumindest einen psychologischen
        Erfolg vermelden: Sie versenken im Hafen von Berdjansk das russische{' '}
        <Bold>Kriegsschiff Moskwa</Bold> mit zwei Raketentreffern. Die Moskwa
        ist der Stolz der russischen Schwarzmeerflotte,{' '}
        <Stink href='506533229739'>
          ihr Verlust ein schwerer Schlag für die Russen.
        </Stink>
      </p>

      <Image
        src={require('../../assets/images/moskwa.jpg')}
        caption='Tauchte in den sozialen Medien auf: Eine mutmassliche Aufnahme der beschädigten Moskwa kurz vor ihrem Untergang.'
        source='Foto: BormanIke (Twitter)'
      />
    </>
  ),
  '2022-05-18': (
    <>
      <p>
        Russlands Präsident Wladimir Putin will Vergeltung und seiner
        Bevölkerung zum «Tag des Sieges» am 9. Mai (Tag des Sieges der
        Sowjetunion über Nazi-Deutschland im Zweiten Weltkrieg) unbedingt einen
        Erfolg in der Ukraine präsentieren. Das gelingt nicht.{' '}
        <Stink href='577803226350'>
          Aber Mitte Mai können die Russen nach fast drei Monaten andauernden
          blutigen Kämpfen
        </Stink>{' '}
        <BR>Mariupol</BR> <Stink href='577803226350'>einnehmen.</Stink>
      </p>
      <p>
        Die eingekesselte Stadt gilt bis zur Aufgabe der letzten Kämpfer, die
        sich in einem Stahlwerk verschanzt haben, als Symbol des ukrainischen
        Widerstands. Nun ist sie weitgehend zerstört. Tausende Zivilisten sind
        gestorben.
      </p>
       <div style={{ position: 'relative', paddingBottom: '56.25%' }}>
        <iframe
          data-mimetype='x-videocms/video'
          data-id='uv444397'
          data-duration='75'
          data-preview-url='https://unitythumb.appuser.ch/frames/uv444397/frame-50-444397.jpg'
          data-title='Mariupol vor und nach den russischen Angriffen'
          data-lead='Die Hafenstadt in der Ukraine wurde heftig von russischem Beschuss und Luftangriffen getroffen und zerstört.'
          src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@444397|showLogo@1|autoStart@0|mute@0|previewPath@https://unitythumb.appuser.ch/frames/uv444397/frame-50-444397.jpg|platform@desktop'
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            border: 0,
          }}
        ></iframe> 
     </div>
      <Caption>
        Nur noch Ruinen: In der Stadt Mariupol steht fast nichts mehr.
      </Caption>
      <Source>Video: Tamedia</Source> 
    </>
  ),
  '2022-05-30': (
    <>
      <p>
        Für die russische Propaganda ist die Eroberung Mariupols hoch
        willkommen. Das weitaus wichtigere Ziel bleibt für Putin die Kontrolle
        über den <BHB>Donbass.</BHB> In dieser Phase machen seine Truppen aber
        keine grossen Fortschritte im Osten. Und im Süden werden sie sogar von den Ukrainern zurückgedrängt. Insgesamt verschieben sich die Frontlinien im Spätfrühling nur wenige Kilometer.
      </p>
    </>
  ),
  '2022-06-30': (
    <>
      <Chapter>
        4 &ndash; Verlustreiche Kämpfe
        <span className='date'>Juni bis August 2022</span>
        <span>Beide Seiten können Erfolge vermelden</span>
      </Chapter>

      <p>
        <Stink href='682680348936'>
          Erst Ende Juni sorgt wieder eine militärische Aktion für Aufsehen:
        </Stink>{' '}
        Ukrainische Truppen bringen die strategisch bedeutsame{' '}
        <B>Schlangen&shy;insel</B> im Schwarzen Meer wieder unter ihre
        Kontrolle. Die Russen hatten das Eiland gleich am 24. Februar, dem
        ersten Kriegstag, besetzt und zur Luftverteidigung genutzt.
      </p>

      <Image
        src={require('../../assets/images/snakeislandsat.jpg')}
        caption='Satellitenaufnahmen zeigen die Zerstörung: Nach massiven Raketen- und Artillerieangriffen haben die russischen Truppen die Schlangeninsel verlassen.'
        source='Foto: Maxar'
      />

      <p>
        Die nun erfolgte Rückeroberung ist kein Gamechanger im Krieg, aber
        symbolisch wichtig. Zudem kontrollieren die Ukrainer wieder Teile ihrer
        Küste und Schifffahrtswege.
      </p>

      <Image
        src={require('../../assets/images/stamp.jpg')}
        caption='«Russisches Kriegsschiff, f… dich!»: Mit diesem Funkspruch antwortete der Soldat Roman Hrybow auf die russische Forderung zur Kapitulation der Schlangeninsel. Im Nachgang widmet ihm die ukrainische Post eine Sonderbriefmarke.'
        source='Bild: Ukrposchta'
      />

      <p>
        Die Russen reden von einem «Zeichen des guten Willens» und behaupten,
        sie seien freiwillig gegangen. Tatsache ist: Um die Insel wird seit
        Kriegsbeginn gekämpft. Und die Ukrainer wollten sie unbedingt zurück.
        Denn die 13 Soldaten, welche die Insel beim Angriff im Februar
        verteidigten, werden als Helden gefeiert. Die ukrainische Post widmete
        ihnen sogar eine Sonderbriefmarke, weil sie sich damals der
        Kapitulationsaufforderung des russischen Kriegsschiffes Moskwa
        widersetzten.
      </p>
    </>
  ),
  '2022-07-04': (
    <>
      <p>
        Die russischen Streitkräfte stossen derweil im Donbass weiter vor. Die
        stark industrialisierte Region im Osten der Ukraine wird zum Schauplatz
        der grössten Schlacht in Europa seit Generationen. Unter grossen
        Verlusten nehmen die Russen Anfang Juli <BR>Lissitschansk</BR> ein, die
        letzte ukrainisch kontrollierte Stadt in der Region Luhansk – es sollte
        ihr letzter bedeutender Sieg für längere Zeit sein.
      </p>
    </>
  ),
  '2022-08-10': (
    <>
      <p>
        Die Ukrainer setzen immer wieder Nadelstiche. Im August intensivieren
        sie ihre Gegenoffensive in der <BR>Region Cherson</BR> im Süden. Dabei
        setzen sie unter anderem den hochpräzisen US-Raketenwerfer Himars ein,
        mit dem sie russische Stellungen und Infrastruktur weit hinter den
        Frontlinien angreifen können.
      </p>
      <p>
        Zudem verüben die Ukrainer, womöglich mithilfe von Partisanen, einen
        Anschlag auf den russischen <B>Luftwaffenstützpunkt bei Saki</B> auf der
        Krim. Von der Halbinsel aus, welche die Russen 2014 völkerrechtswidrig
        annektiert haben, werden immer wieder Angriffe auf ukrainische Städte
        geflogen.
      </p>
      <p>
        Moskau spricht von einem Unfall, ein Feuer habe Munition zur Explosion
        gebracht.{' '}
        <Stink href='679014047012'>
          Doch Satellitenbilder zeigen mehrere grosse Krater, was auf präzise
          Treffer mit Langstreckenmunition hindeutet.
        </Stink>{' '}
        Die Russen verlieren auf einen Schlag bis zu vierzehn Flugzeuge und
        Helikopter.
      </p>
      <Image
        src={require('../../assets/images/airbase.jpg')}
        caption='Mehrere Krater von Raketeneinschlägen: Dieses Satellitenbild zeigt die Zerstörung von mindestens sieben russischen Kampfjets auf dem Stützpunkt bei Saki.'
        source='Foto: Planet Labs PBC (AP, Keystone)'
      />
      <p>
        Für Putins Propaganda ist der Vorfall eine Katastrophe – auch, weil
        Hunderte russische Touristen den Angriff am Strand der Krim live
        miterlebt haben und ihre Videos und Bilder viralgehen.
      </p>
      <Image
        src={require('../../assets/images/beach.jpg')}
        caption='Explosionen und Rauchsäulen: Der Anschlag auf den Luftwaffenstützpunkt unterbricht die Sommerferien von russischen Touristen jäh.'
        source='Foto: UGC (AP, Keystone)'
      />
    </>
  ),
  '2022-08-31': (
    <>
      <p>
        Auch auf dem Schlachtfeld kommen die Russen in dieser Phase nicht mehr
        voran. Im Süden geraten sie angesichts der grossen Gegenoffensive in der
        Region Cherson immer mehr unter Druck. Die Ukrainer greifen nicht nur an
        der Front an, sondern auch hinter den Linien. So nehmen sie zum Beispiel
        mehrfach den Staudamm bei <B>Nowa Kachowka</B> ins Visier, einen der
        wenigen Übergänge über den Fluss Dnjepr, und unterbrechen so eine
        wichtige russische Nachschublinie.
      </p>
      <p>
        Am 20. August folgt der nächste GAU für die Russen:{' '}
        <Stink href='343442748227'>
          Darja Dugina, Tochter des rechten Ideologen und «Putin-Einflüsterers»
          Alexander Dugin, stirbt durch eine Autobombe in der Nähe von Moskau.
        </Stink>{' '}
        Der Anschlag im Herzen Russlands hat wohl ihrem Vater gegolten und sorgt
        im Kreml für Entsetzen. «Ukrainische Terroristen» werden beschuldigt.
        Bis heute ist aber nicht klar, wer wirklich dahintersteckt.
      </p>

      <Image
        src={require('../../assets/images/dugina.jpg')}
        caption='Vom Auto Duginas sind nur noch Trümmerteile übrig: Ermittler untersuchen den Ort der Explosion nach Spuren.'
        source='Foto: Investigative Committee of Russia (AP, Keystone)'
      />
    </>
  ),
  '2022-09-06': (
    <>
      <Chapter>
        5 &ndash; Riesige Gegenoffensive
        <span className='date'>September bis November 2022</span>
        <span>
          Die Ukrainer erobern den ganzen Nordosten und Teile des Südens zurück
        </span>
      </Chapter>

      <p style={{ textAlign: 'center' }}>
        <img
          src={require('../../assets/overviews_map_northeast.png')}
          style={{ maxWidth: '300px' }}
        />
      </p>
      <p>
        Im Norden und im Osten haben sich die Frontlinien seit Monaten nur
        marginal verändert. Doch am 6. September starten die ukrainischen
        Streitkräfte eine überraschende und gross angelegte Offensive in der
        Region Charkiw. Sie brechen bei <B>Balaklija,</B> dem schwächsten Punkt
        der russischen Stellungen, durch.
      </p>
    </>
  ),
  '2022-09-12': (
    <>
      <p>
        Die dort stationierten russischen Einheiten müssen die Flucht ergreifen.
        Moskau begründet den Rückzug mit einer «strategischen Umgruppierung».
        Doch in Wahrheit kollabieren die russischen Verteidigungslinien so
        schnell, dass selbst Experten überrascht sind. Innerhalb von nur einer
        Woche <IB>vertreiben die Ukrainer die Besatzer aus dem Nordosten</IB>{' '}
        des Landes. Es ist neben der Befreiung des Nordens im April ihr grösster Triumph bislang.
      </p>

      <Image
        src={require('../../assets/images/isiumselenski.jpg')}
        caption='Reist nur zwei Tage nach der Rückeroberung an die Front: Selenski am 14. September im ostukrainischen Isjum.'
        source='Foto: Presidential Press Service Ukraine (EPA)'
      />

      <p>
        Die Ukrainer erobern zahlreiche Ortschaften zurück, darunter die{' '}
        <B>Städte Kupjansk und Isjum.</B> Beides sind strategisch wichtige
        Verkehrs&shy;knotenpunkte, welche die Russen für ihren Nachschub
        nutzten. Die Transportmöglichkeiten verbessern sich massiv für die
        ukrainischen Truppen. Aber ihre Freude über den Sieg wird durch den
        erneuten Fund von Massengräbern und Hinweisen auf russische
        Kriegsverbrechen getrübt, unter anderem in Isjum.
      </p>

      <Image
        src={require('../../assets/images/isium.jpg')}
        caption='Wirkt schockiert: Ein ukrainischer Rettungssanitäter während Exhumierungsarbeiten an einer Grabstätte bei Isjum. '
        source='Foto: Oleg Petrasyuk (EPA, Keystone)'
      />
    </>
  ),
  '2022-09-30': (
    <>
      <p>
        <Stink href='356990142292'>
          Putin reagiert mit einer Teilmobilmachung von 300’000 Mann auf die
          schmachvolle Niederlage.
        </Stink>{' '}
        Zudem lässt er in den besetzten Gebieten – Teile der{' '}
        <B>Regionen Cherson, Saporischschja, Donezk und Luhansk</B> –
        Scheinreferenden durchführen. Seine Soldaten gehen von Haustür zu
        Haustür. Wer nicht Ja sagt zum Anschluss an Russland, riskiert sein
        Leben. Und so ist das Resultat schon von vornherein bekannt.{' '}
        <Stink href='395413099021'>
          Ende September verkündet Putin die völkerrechtswidrige Annexion
          feierlich.
        </Stink>
      </p>

      <Image
        src={require('../../assets/images/putinparty.jpg')}
        caption='«Ro-ssi-ja, Ro-ssi-ja»: Putin zusammen mit moskautreuen Vertretern von Luhansk, Donezk, Cherson und Saporischschja.'
        source='Foto: AFP'
      />
    </>
  ),
  '2022-10-08': (
    <>
      <p>
        Doch kurze Zeit später müssen die Russen schon wieder eine Demütigung
        hinnehmen:{' '}
        <Stink href='592104197547'>
          Am 8. Oktober – einen Tag nach Putins Geburtstag – wird die
        </Stink>{' '}
        <B>Kertsch-Brücke</B>{' '}
        <Stink href='592104197547'>stark beschädigt.</Stink> Sie verbindet die
        besetzte Halbinsel Krim mit dem russischen Festland und ist sehr wichtig
        für den Nachschub in der Südukraine.
      </p>
      <p>
        Eine gewaltige Explosion und ein schwerer Brand lassen die Fahrbahn an
        mindestens zwei Stellen einstürzen. Die Attacke auf Putins
        Prestigeobjekt ist ein weiterer Erfolg der Ukrainer in Herbst. Der
        ukrainische Geheimdienst soll den Anschlag geplant haben.
      </p>
       <div style={{ position: 'relative', paddingBottom: '56.25%' }}> 
         <iframe
          data-mimetype='x-videocms/video'
          data-id='uv446509'
          data-duration='94'
          data-preview-url='https://unitythumb.appuser.ch/frames/uv446509/frame-1-446509.jpg'
          data-title='Brand auf der Krim-Brücke'
          data-lead='Auf der Krim-Brücke kam es zu einem Grossbrand. Sollte die Explosion auf die Urheberschaft der Ukraine zurückgehen, wäre dies ein herber Schlag für Moskau. '
          src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger%7CvideoId@446509%7CshowLogo@1%7CautoStart@0%7Cmute@0%7C%7CpreviewPath@https://unitythumb.appuser.ch/frames/uv446509/frame-1-446509.jpg%7Cplatform@desktop'
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            border: 0,
          }}
        ></iframe> 
      </div> 
     <Caption>
        Wurde von Überwachungskameras aufgezeichnet: Die Explosion auf der
        Kertsch-Brücke.
      </Caption>
     <Source>Video: Tamedia</Source>
    </>
  ),
  '2022-10-10': (
    <>
      <p>
        Russland hatte immer wieder betont, dass ein Angriff auf die Brücke ein
        klares Überschreiten der roten Linie sei. Und prompt üben seine
        Streitkräfte nur zwei Tage später einen Vergeltungsschlag aus, indem sie{' '}
        <Bold>zahlreiche ukrainische Städte</Bold> mit Raketen beschiessen.{' '}
        <Stink href='105142012935'>
          Es ist der Beginn einer Kampagne, mit der die Energieinfrastruktur des
          Landes zerstört und die Bevölkerung demoralisiert werden soll.
        </Stink>
      </p>
    </>
  ),
  '2022-11-15': (
    <>
      <p>
        Im November folgt ein weiterer bedeutender Sieg der Ukrainer. Unter dem
        steigenden Druck immer neuer Angriffe ziehen sich die russischen Truppen
        im Süden bis ans Ostufer des Flusses Dnjepr zurück. Die Ukrainer erobern
        grosse Teile der eben erst von Russland annektierten{' '}
        <BR>Region Cherson</BR> zurück.
      </p>
      <p>
        In der gleichnamigen Stadt strömen die Menschen jubelnd auf die Strassen
        und begrüssen die ukrainischen Soldaten mit Fahnen, Umarmungen und
        Blumen. Es sind die ersten positiven Bilder aus dem kriegsgeschüttelten
        Land seit langer Zeit.
      </p>

      <Image
        src={require('../../assets/images/cherson.jpg')}
        caption='Wieder mal ein Grund zur Freude: Einwohner von Cherson applaudieren und herzen ukrainische Soldaten nach ihrer Rückeroberung der Stadt.'
        source='Foto: Efrem Lukatsky (AP, Keystone)'
      />
    </>
  ),
  '2022-12-01': (
    <>
      <Chapter>
        6 &ndash; Eine Pattsituation
        <span className='date'>Dezember 2022 bis Januar 2023</span>
        <span>Die Fronten frieren im Winter ein</span>
      </Chapter>
      <p>
        Allmählich hält der Winter Einzug in der Ukraine. Schlamm und Matsch
        machen viele Wege unpassierbar. Schnelle Vorstösse sind kaum mehr
        möglich, und die Fronten frieren sprichwörtlich ein. Das spielt vor
        allem den russischen Truppen in die Karten, die in den vergangenen
        Monaten arg in Bedrängnis geraten sind. Für die Ukrainer hingegen kommt
        die kalte Jahreszeit zu einem denkbar schlechten Zeitpunkt.
      </p>

      <Image
        src={require('../../assets/images/winter.jpg')}
        caption='Steckt im Schlamm fest: Ein russischer Panzer T-80, der an der Frontlinie in der Region Donezk von ukrainischen Soldaten erbeutet wurde. '
        source='Foto: AP, Keystone'
      />

      <p>
        Die Russen bauen vielerorts ihre Verteidigungspositionen aus. Denn sie
        brauchen Zeit, um sich zu verstärken und neu zu gruppieren. Gleichzeitig
        setzen sie ihre Raketen- und Drohnenangriffe auf die zivile
        Infrastruktur der Ukraine fort. Es kommt regelmässig zu Stromausfällen
        und zivilen Opfern, etwa in{' '}
        <Bold>Kiew, Charkiw, Dnipro und Odessa.</Bold>
      </p>
      <p>
        Der Kreml bezeichnet die Invasion weiterhin als «militärische
        Spezialoperation». Erst an Weihnachten verwendet Putin zum ersten Mal
        öffentlich das Wort «Krieg» und erklärt, Russland sei «bereit, mit der
        Ukraine zu verhandeln» – eine Forderung, die von der ukrainischen
        Führung abgelehnt wird.
      </p>
      <Image
        src={require('../../assets/images/putin.jpg')}
        caption='Jetzt ist es doch «Krieg»: Putin lässt die Ukraine bombardieren und zeigt sich gleichzeitig bereit zu Verhandlungen.'
        source='Foto: Sergey Guneev (Kremlin Pool Photo, AP)'
      />
    </>
  ),
  '2023-01-02': (
    <>
      <p>
        Die Ukrainer versuchen weiter, russische Ziele zu treffen, die teilweise
        weit hinter den Frontlinien sind. Im Dezember wird zum Beispiel zweimal
        der Luftwaffenstützpunkt Engels mit Drohnen attackiert, der nahe der
        russischen Stadt Swatowe liegt, etwa 480 Kilometer von der ukrainischen
        Grenze entfernt.
      </p>
      <p>
        In der Neujahrsnacht gelingt den Ukrainern dann ein grösserer Schlag:
        Sie treffen mit einem Raketenangriff auf <Bold>Makijiwka</Bold> bei
        Donezk eine russische Militärunterkunft. Laut Moskau sterben 89
        Soldaten. Kiew spricht von Hunderten Toten und Verletzten.
      </p>
    </>
  ),
  '2023-01-10': (
    <>
      <Chapter>
        7 &ndash; Neue Offensive
        <span className='date'>Januar bis Februar 2023</span>
        <span>
          Die Russen wollen endgültig den ganzen Donbass kontrollieren
        </span>
      </Chapter>

      <p>
        Schon im Dezember warnen die Ukrainer vor einer neuen Grossoffensive des
        Gegners, deren Vorbereitungen in vollem Gange seien. Sogar die
        Hauptstadt Kiew soll wieder im Visier der Russen sein. Zunächst
        konzentrieren sich die Invasoren aber auf den Donbass, den sie ganz
        kontrollieren wollen, und starten die erwartete Offensive.
      </p>
      <p style={{ textAlign: 'center' }}>
        <img
          src={require('../../assets/overviews_map_bachmut.png')}
          style={{ maxWidth: '300px' }}
        />
      </p>
      <p>
        Zum ersten Mal seit langem stossen sie hier wieder entscheidend vor.
        Schritt für Schritt nähern sie sich <B>Bachmut,</B> das sie schon seit
        dem Sommer erobern wollen – es ist mittlerweile die längste Schlacht
        dieses Krieges. Die Stadt ist zu einem Symbol des ukrainischen
        Widerstands geworden, wenngleich die Meinungen über deren strategische
        Bedeutung auseinandergehen.
      </p>
    </>
  ),
  '2023-01-20': (
    <>
      <p>
        Sowohl die ukrainischen als auch die russischen Streitkräfte haben in
        dieser Region viele Befestigungen errichtet. Es gibt Schützengräben und
        Stellungskämpfe wie im Ersten Weltkrieg. Unter schweren Verlusten nehmen
        die Russen Mitte Januar aber die <B>Kleinstadt Soledar</B> nebenan ein.
        Damit ist Bachmut so gut wie eingekreist.
      </p>

      <Image
        src={require('../../assets/images/artillery.jpg')}
        caption='Trotz grossem Widerstand: Die ukrainischen Truppen, hier bei einem Artilleriegefecht, sind rund um Bachmut in die Defensive geraten.'
        source='Foto: AP, Keystone'
      />
      <p>
        <Stink href='203221285930'>
          Russland steht kurz vor dem ersten Sieg seit Monaten.
        </Stink>{' '}
        Die Eroberung Bachmuts wäre der erste richtige Erfolg auf dem
        Schlachtfeld seit der Einnahme der Stadt Lissitschansk im Juli, was den
        Invasoren sicher einen moralischen Schub verleihen würde.
      </p>
    </>
  ),
  '2023-02-16': (
    <>
      <p>
        Zudem ist Bachmut laut Experten das Tor zu den urbanen Zentren des
        Donbass, zu <B>Slowjansk oder Kramatorsk.</B> Auch eine neue
        Angriffsachse in Richtung <B>Siwersk</B> ist denkbar, womit ukrainische
        Truppen eingekesselt werden könnten. Das vielzitierte Momentum würde
        wieder auf die Seite Russlands kippen – vielleicht ist es das sogar
        schon.
      </p>
      <p>
        Dem ukrainischen Geheimdienst zufolge soll Putin die Eroberung des
        gesamten Donbass bis im März befohlen haben. Nach Auffassung des
        US-Geheimdienstes CIA wird sich der Ausgang des Kriegs in den nächsten
        sechs Monaten auf dem Schlachtfeld entscheiden. Die Ukrainer
        prognostizieren die schwersten Gefechte seit Kriegsbeginn in den
        nächsten zwei bis drei Monaten. Bachmut könnte sich dann als Wendepunkt
        erweisen.
      </p>
    </>
  ),
}
